/* ============================================================
   PRINTTEXX — THEME JAVASCRIPT
   Ultra Premium Shopify Theme Interactions
   ============================================================ */

'use strict';

/* ============================================================
   INIT
   ============================================================ */
document.addEventListener('DOMContentLoaded', () => {
  initLoadingScreen();
  initCustomCursor();
  initScrollIndicator();
  initScrollHeader();
  initParallaxHero();
  initFadeInObserver();
  initProductCard3D();
  initCarousel();
  initAccordion();
  initProductThumbnails();
  initVariantButtons();
  initCartForm();
});

/* ============================================================
   LOADING SCREEN
   ============================================================ */
function initLoadingScreen() {
  const screen = document.getElementById('loading-screen');
  if (!screen) return;

  // Lock scroll while loading
  document.body.style.overflow = 'hidden';

  // Hide after animation (logo letters finish at ~1.4s + slight pause)
  setTimeout(() => {
    screen.classList.add('hidden');
    document.body.style.overflow = '';

    // Fire fade-in for initially-visible elements
    triggerVisibleFadeIns();
  }, 900);
}

/* ============================================================
   CUSTOM CURSOR
   ============================================================ */
function initCustomCursor() {
  const cursorDot   = document.getElementById('cursor');
  const cursorRing  = document.querySelector('.cursor-outer');
  if (!cursorDot || !cursorRing) return;

  // Only on non-touch devices
  if ('ontouchstart' in window) return;

  let mouseX = -100, mouseY = -100;
  let ringX  = -100, ringY  = -100;
  let raf;

  document.addEventListener('mousemove', (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    cursorDot.style.left = mouseX + 'px';
    cursorDot.style.top  = mouseY + 'px';
  });

  // Smooth lag for outer ring
  function animateRing() {
    ringX += (mouseX - ringX) * 0.14;
    ringY += (mouseY - ringY) * 0.14;
    cursorRing.style.left = ringX + 'px';
    cursorRing.style.top  = ringY + 'px';
    raf = requestAnimationFrame(animateRing);
  }
  raf = requestAnimationFrame(animateRing);

  // Scale on interactive elements
  const interactives = document.querySelectorAll(
    'a, button, .product-card, .showcase-card, .variant-btn, .accordion-header, .product-thumb'
  );

  interactives.forEach(el => {
    el.addEventListener('mouseenter', () => {
      cursorDot.querySelector('.cursor-inner').style.transform  = 'scale(2.5)';
      cursorRing.style.width        = '52px';
      cursorRing.style.height       = '52px';
      cursorRing.style.borderColor  = 'rgba(26, 26, 26, 0.5)';
      cursorRing.style.background   = 'rgba(26, 26, 26, 0.04)';
    });
    el.addEventListener('mouseleave', () => {
      cursorDot.querySelector('.cursor-inner').style.transform  = 'scale(1)';
      cursorRing.style.width        = '34px';
      cursorRing.style.height       = '34px';
      cursorRing.style.borderColor  = 'rgba(26, 26, 26, 0.3)';
      cursorRing.style.background   = 'transparent';
    });
  });

  // Hide when leaving window
  document.addEventListener('mouseleave', () => {
    cursorDot.style.opacity  = '0';
    cursorRing.style.opacity = '0';
  });
  document.addEventListener('mouseenter', () => {
    cursorDot.style.opacity  = '1';
    cursorRing.style.opacity = '1';
  });
}

/* ============================================================
   SCROLL PROGRESS INDICATOR
   ============================================================ */
function initScrollIndicator() {
  const bar = document.getElementById('scroll-indicator');
  if (!bar) return;

  const update = () => {
    const scrollTop  = window.scrollY;
    const docHeight  = document.documentElement.scrollHeight - window.innerHeight;
    const progress   = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    bar.style.width  = Math.min(progress, 100) + '%';
  };

  window.addEventListener('scroll', update, { passive: true });
}

/* ============================================================
   STICKY HEADER ON SCROLL
   ============================================================ */
function initScrollHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const update = () => {
    header.classList.toggle('scrolled', window.scrollY > 60);
  };

  window.addEventListener('scroll', update, { passive: true });
}

/* ============================================================
   HERO PARALLAX
   ============================================================ */
function initParallaxHero() {
  const product = document.getElementById('hero-product');
  if (!product) return;

  // Only on non-mobile
  if (window.innerWidth < 768) return;

  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        const y = window.scrollY;
        product.style.transform = `translate(-50%, calc(-50% + ${y * 0.22}px))`;
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
}

/* ============================================================
   FADE-IN ON SCROLL (IntersectionObserver)
   ============================================================ */
function initFadeInObserver() {
  const elements = document.querySelectorAll('.fade-in');
  if (!elements.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
  );

  elements.forEach(el => observer.observe(el));
}

// Fire for elements already in viewport (called after loading screen hides)
function triggerVisibleFadeIns() {
  const elements = document.querySelectorAll('.fade-in:not(.visible)');
  elements.forEach(el => {
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.92) {
      el.classList.add('visible');
    }
  });
}

/* ============================================================
   PRODUCT CARD 3D HOVER
   ============================================================ */
function initProductCard3D() {
  const cards = document.querySelectorAll('.product-card');

  cards.forEach(card => {
    const img = card.querySelector('.product-card-image img, .product-card-image .placeholder-img');
    if (!img) return;

    card.addEventListener('mousemove', (e) => {
      const rect  = card.getBoundingClientRect();
      const xPct  = (e.clientX - rect.left) / rect.width  - 0.5;
      const yPct  = (e.clientY - rect.top)  / rect.height - 0.5;

      img.style.transform = `
        perspective(900px)
        rotateY(${xPct * 9}deg)
        rotateX(${-yPct * 9}deg)
        scale(1.05)
      `;
    });

    card.addEventListener('mouseleave', () => {
      img.style.transform = `
        perspective(900px) rotateY(0deg) rotateX(0deg) scale(1)
      `;
    });
  });
}

/* ============================================================
   DRAGGABLE CAROUSEL (Showcase)
   ============================================================ */
function initCarousel() {
  const container = document.querySelector('.showcase-scroll-container');
  if (!container) return;

  let isDown   = false;
  let startX   = 0;
  let scrollLeft = 0;

  container.addEventListener('mousedown', (e) => {
    isDown = true;
    container.style.cursor = 'grabbing';
    startX     = e.pageX - container.offsetLeft;
    scrollLeft = container.scrollLeft;
  });

  container.addEventListener('mouseleave', end);
  container.addEventListener('mouseup', end);
  container.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x    = e.pageX - container.offsetLeft;
    const walk = (x - startX) * 1.6;
    container.scrollLeft = scrollLeft - walk;
  });

  function end() {
    isDown = false;
    container.style.cursor = '';
  }
}

/* ============================================================
   ACCORDION
   ============================================================ */
function initAccordion() {
  const headers = document.querySelectorAll('.accordion-header');

  headers.forEach(header => {
    header.addEventListener('click', () => {
      const body   = header.nextElementSibling;
      const icon   = header.querySelector('.accordion-icon');
      const isOpen = body.classList.contains('open');

      // Close all
      document.querySelectorAll('.accordion-body').forEach(b => b.classList.remove('open'));
      document.querySelectorAll('.accordion-icon').forEach(i => {
        i.textContent = '+';
        i.style.transform = '';
      });

      // Toggle clicked
      if (!isOpen) {
        body.classList.add('open');
        if (icon) {
          icon.textContent   = '−';
          icon.style.transform = 'rotate(180deg)';
        }
      }
    });
  });
}

/* ============================================================
   PRODUCT THUMBNAILS
   ============================================================ */
function initProductThumbnails() {
  const thumbs  = document.querySelectorAll('.product-thumb');
  const mainImg = document.querySelector('#main-product-image');

  if (!thumbs.length || !mainImg) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');

      const fullSrc = thumb.dataset.full || thumb.src;
      // Crossfade
      mainImg.style.opacity = '0';
      mainImg.style.transition = 'opacity 0.35s ease';
      setTimeout(() => {
        mainImg.src = fullSrc;
        mainImg.style.opacity = '1';
      }, 200);
    });
  });
}

/* ============================================================
   VARIANT BUTTONS
   ============================================================ */
function initVariantButtons() {
  const variantGroups = document.querySelectorAll('.variant-options');

  variantGroups.forEach(group => {
    const buttons = group.querySelectorAll('.variant-btn');
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        // Could update hidden input here for real variant selection
      });
    });
  });
}

/* ============================================================
   CART FORM — AJAX ADD TO CART
   ============================================================ */
function initCartForm() {
  const form = document.getElementById('product-form');
  if (!form) return;

  const btn = form.querySelector('.product-add-cart');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const formData = new FormData(form);
    const variantId = formData.get('id');

    if (!variantId) return;

    btn.disabled    = true;
    btn.textContent = 'Wird hinzugefügt…';

    try {
      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (resp.ok) {
        btn.textContent = '✓ Hinzugefügt';
        btn.style.borderColor = '#4a9e4a';
        updateCartCount();

        setTimeout(() => {
          btn.textContent      = 'In den Warenkorb';
          btn.style.borderColor = '';
          btn.disabled         = false;
        }, 2500);
      } else {
        throw new Error('Add to cart failed');
      }
    } catch (err) {
      btn.textContent = 'Fehler — Bitte erneut';
      btn.disabled    = false;
      console.error(err);
    }
  });
}

/* ============================================================
   UPDATE CART COUNT IN HEADER
   ============================================================ */
async function updateCartCount() {
  try {
    const resp = await fetch('/cart.js');
    const data = await resp.json();
    const el   = document.querySelector('.cart-count');
    if (el) {
      el.textContent  = data.item_count;
      el.style.transform = 'scale(1.4)';
      setTimeout(() => el.style.transform = '', 300);
    }
  } catch (e) {
    // Silently fail
  }
}

/* ============================================================
   SMOOTH SECTION REVEAL UTILITY
   (called for sections that appear with JS scroll effects)
   ============================================================ */
window.addEventListener('scroll', () => {
  triggerVisibleFadeIns();
}, { passive: true });
